export enum Status {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    INVITED = 'INVITED',
    BLOCKED = 'BLOCKED'
}

export enum NotificationGroup {
    REPORT = 'REPORT',
    WATCH = 'WATCH '
}

export enum EntityType {
    FORM_1065 = 'FORM_1065',
    FORM_1120S = 'FORM_1120S',
    FORM_1120 = 'FORM_1120',
    SCHEDULE_C = 'SCHEDULE_C'
}

export enum TransactionType {
    CHANGE_OWNERSHIP = 'CHANGE_OWNERSHIP',
    BUYOUT = 'BUYOUT',
    REFINANCING = 'REFINANCING',
    OTHER = 'OTHER',
    THIRD_PARTY_BUYOUT = 'THIRD_PARTY_BUYOUT',
    PARTNER_BUYOUT = 'PARTNER_BUYOUT'
}

export enum LocationType {
    RETAIL = 'RETAIL',
    INDUSTRIAL = 'INDUSTRIAL',
    OFFICE = 'OFFICE',
    OTHER = 'OTHER'
}

export enum AdjustmentType {
    NON_RECURRING_EXPENSE = 'NON_RECURRING_EXPENSE',
    NON_OPERATING_EXPENSE = 'NON_OPERATING_EXPENSE',
    NON_RECURRING_INCOME = 'NON_RECURRING_INCOME',
    NON_OPERATING_INCOME = 'NON_OPERATING_INCOME',
    OTHER = 'OTHER'
}

export enum FinancialType {
    NOT_ENTERED = 'NOT_ENTERED',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    INTERNAL = 'INTERNAL',
    FEDERAL_TAX_RETURNS = 'FEDERAL_TAX_RETURNS',
    ACCOUNTANT_COMPILED = 'ACCOUNTANT_COMPILED',
    ACCOUNTANT_REVIEWED = 'ACCOUNTANT_REVIEWED',
    AUDITED = 'AUDITED',
    FORECASTED = 'FORECASTED'
}

export enum IncomeStatementType {
    HISTORICAL = 'HISTORICAL',
    INTERIM = 'INTERIM',
    FORECASTED = 'FORECASTED'
}

export enum ReportMode {
    ALL_PROJECTS = 'ALL_PROJECTS',
    MY_PROJECTS = 'MY_PROJECTS',
    SHARED_WITH_ME = 'SHARED_WITH_ME'
}

export enum SortByMode {
  EVALUATION_DATE_NEWEST_FIRST = 'EVALUATION_DATE_NEWEST_FIRST',
  EVALUATION_DATE_OLDEST_FIRST = 'EVALUATION_DATE_OLDEST_FIRST',
  COMPANY_DBA = 'COMPANY_DBA',
  REPORT_PROGRESS_FILLED_FIRST = 'REPORT_PROGRESS_FILLED_FIRST',
  REPORT_PROGRESS_EMPTY_FIRST = 'REPORT_PROGRESS_EMPTY_FIRST',
  FINAL_VALUE_BIG_FIRST = 'FINAL_VALUE_BIG_FIRST',
  FINAL_VALUE_SMALL_FIRST = 'FINAL_VALUE_SMALL_FIRST',
}

export enum ReportFilterBy {
    ORGANIZATION = 'ORGANIZATION',
    GENERATOR = 'GENERATOR',
    NAICS = 'NAICS'
}

export enum ReportsSortBy {
    LAST_UPDATED_ON = 'LAST_UPDATED_ON',
    NAICS = 'NAICS',
    ORGANIZATION_NAME = 'ORGANIZATION_NAME',
    CONCLUSION_OF_VALUE = 'CONCLUSION_OF_VALUE',
    PURCHASE_PRICE = 'PURCHASE_PRICE'
}

export enum UsersFilterBy {
  ORGANIZATION = 'ORGANIZATION',
  STATUS = 'STATUS',
}

export enum UsersSortBy {
  NAME_FIRST = 'NAME_FIRST',
  NAME_LAST = 'NAME_LAST',
  LAST_ACTIVITY = 'LAST_ACTIVITY',
  SIGN_UP_DATE = 'SIGN_UP_DATE',
}

export enum OrganizationsSortBy {
    USER_LIMIT = "USER_LIMIT"
}

export enum YesNo {
    YES = 'YES',
    NO = 'NO'
}

export enum CustomersCount {
    _1_TO_5 = '_1_TO_5',
    _6_TO_10 = '_6_TO_10',
    _11_TO_25 = '_11_TO_25',
    _26_TO_100 = '_26_TO_100',
    TOO_MANY_TO_COUNT = 'TOO_MANY_TO_COUNT'
}

export enum OwnerLeave {
    NO_CHANGE = 'NO_CHANGE',
    FINDING_INDIVIDUAL_EASY = 'FINDING_INDIVIDUAL_EASY',
    FINDING_INDIVIDUAL_DIFFICULT = 'FINDING_INDIVIDUAL_DIFFICULT',
    FINDING_INDIVIDUAL_DIFFICULT_WITH_LOSS = 'FINDING_INDIVIDUAL_DIFFICULT_WITH_LOSS'
}

export enum LiensesOffer {
    COMPETITOR_NO_OFFER = 'COMPETITOR_NO_OFFER',
    COMPETITOR_POTENTIAL_OFFER = 'COMPETITOR_POTENTIAL_OFFER',
    COMPETITOR_CAN_OFFER = 'COMPETITOR_CAN_OFFER'
}

export enum RecurringAmount {
    _0_TO_25_PERCENT = '_0_TO_25_PERCENT',
    _26_TO_50_PERCENT = '_26_TO_50_PERCENT',
    _51_TO_75_PERCENT = '_51_TO_75_PERCENT',
    _76_TO_100_PERCENT = '_76_TO_100_PERCENT'
}

export enum SalesPercent {
    _50_TO_75_PERCENT = '_50_TO_75_PERCENT',
    _76_TO_100_PERCENT = '_76_TO_100_PERCENT'
}

export enum ShareStatus {
    SHARED = 'SHARED',
    NOT_SHARED = 'NOT_SHARED',
    EDITED = 'EDITED'
}

export enum IncomeStatementActions {
    ANNUALIZE = 'ANNUALIZE',
    LAST_YEAR = 'LAST_YEAR',
    LAST_YEAR_PERCENT = 'LAST_YEAR_PERCENT',
    HISTORICAL = 'HISTORICAL'
}

export enum RentCalculationTypes {
    SQUARE_FOOTAGE = 'SQUARE_FOOTAGE',
    SQUARE_FOOTAGE_AND_MARKET_RENT = 'SQUARE_FOOTAGE_AND_MARKET_RENT',
    APPROXIMATE_VALUE = 'APPROXIMATE_VALUE',
    LEASE_NEGOTIATED = 'LEASE_NEGOTIATED'
}

export enum PageNumbers {
    // ENTITY_REFERENCE = 1,
    // INDUSTRY_NAME = 2,
    // SELLER_BUSINESS = 3,
    // COMPANY_DBA = 4,
    // BUSINESS_ENTITY = 5,
    // FRANCHISE = 6,
    // TRANSACTION_TYPE = 7,
    OVERVIEW = 7,
    // COVID_IMPACT = 8,
    // SERVICE_TYPE = 9,
    // CLOSURES_RESTRICTIONS = 10,
    // ADDITIONAL_DEBT = 11,
    SPECIAL_CONSIDERATION = 11,
    // LOCATION_AMOUNT = 12,
    // LOCATION_DETAILS = 13,
    LOCATION = 13,
    // OWNER_AMOUNT = 14,
    // OWNER_DETAILS = 15,
    OWNERSHIP = 15,
    // YEAR_END = 16,
    // RECENT_FINANCIALS = 17,
    // INCOME_TABLE = 18,
    // FUTURE_YEAR = 19,
    INCOME = 18,
    FUTURE_PROJECTIONS = 19,
    RENT_DETAILS = 20,
    MANAGER_SALARY = 21,
    REPLACEMENT_SALARY = 22,
    ADJUSTMENTS = 23,
    // FUTURE_PREDICTION = 24,
    WEIGHTING_TABLE = 25,
    PROJECTION_TABLE = 26,
    // PURCHASE_PRICE = 27,
    // ASSETS = 28,
    // LIABILITIES = 29,
    ASSETS_LIABILITIES = 29,
    // CUSTOMERS_AMOUNT = 30,
    // DIV15_ANNUAL_REVENUE = 31,
    // DIV50_ANNUAL_REVENUE = 32,
    // NOTABLE_SUPPLIER = 33,
    DIVERSIFICATION = 33,
    PERSONAL_GOODWILL = 34,
    BARRIERS_ENTRY = 35,
    RECURRING_REVENUE = 36,
    CONCLUSION = 37
}

export enum FooterButtonOption {
    NEXT_CLICK = 1,
    BACK_CLICK = 2,
    SKIP_CLICK = 3,
    EXTRA_CLICK = 4
}

export enum ReportState {
    CREATED = 'CREATED',
    LOCKED = 'LOCKED',
    UNLOCKED = 'UNLOCKED',
    NON_BILLABLE = 'NON_BILLABLE'
}

export enum FinalStatus {
    NO_CREDITS = 'NO_CREDITS',
    NEED_UNLOCKING = 'NEED_UNLOCKING',
    OK = 'OK'
}

export enum BusinessPurpose {
    PURCHASE_OR_SALE_BUSINESS = 'PURCHASE_OR_SALE_BUSINESS',
    FINANCIAL_LENDING = 'FINANCIAL_LENDING',
    TAX_PLANNING = 'TAX_PLANNING',
    ESTATE_PLANNING = 'ESTATE_PLANNING',
    MARITAL_DISSOLUTION = 'MARITAL_DISSOLUTION',
    OTHER_LITIGATION_SUPPORT = 'OTHER_LITIGATION_SUPPORT',
    EXIT_PLANNING = 'EXIT_PLANNING',
    OTHER = 'OTHER',
    VERIFY_ASKING_PRICE = 'VERIFY_ASKING_PRICE',
    DETERMINE_SALE_PRICE = 'DETERMINE_SALE_PRICE'
}

export enum CalculationType {
    REVENUE = 'REVENUE',
    SDE = 'SDE'
}

export enum TrendScore {
    UP = 'UP',
    DOWN = 'DOWN',
    FLUCTUATE = 'FLUCTUATE',
    NA = 'NA'
}

export enum PromocodeStatus {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED'
}

export enum PromocodeType {
    CREDIT = "CREDIT",
    SUBSCRIPTION = "SUBSCRIPTION",
    ALL = "ALL"
}

export enum OrderAscDesc {
    ASC = 'ASC',
    DESC = 'DESC'
}

export enum OrganizationType {
    BANK = 'BANK',
    ACCOUNTING_FIRM = 'ACCOUNTING_FIRM',
    SBDC = 'SBDC' // Small Business Development Center (SBDC)
}

export enum PortalTheme {
    DEFAULT = 'DEFAULT',
    NIGHT_BLUE = 'NIGHT_BLUE',
    PURPLE = 'PURPLE',
    TIFFANY_BLUE = 'TIFFANY_BLUE',
    JUNGLE_GREEN = 'JUNGLE_GREEN',
    HONEY_YELLOW = 'HONEY_YELLOW'
}

export enum PortalPrimaryColor {
    DEFAULT = '#4164E2',
    NIGHT_BLUE = '#18108D',
    PURPLE = '#6534D6',
    TIFFANY_BLUE = '#01AFAF',
    JUNGLE_GREEN = '#01AF87',
    HONEY_YELLOW = '#EDAC10'
}

export enum PortalSecondaryColor {
    DEFAULT = '#ecf0fd',
    NIGHT_BLUE = '#F5F4FE',
    PURPLE = '#F6F2FF',
    TIFFANY_BLUE = '#EAF8F9',
    JUNGLE_GREEN = '#EDFDF3',
    HONEY_YELLOW = '#FFFDF2'
}

export enum PortalDisabledColor {
    DEFAULT = '#a0b2f0',
    NIGHT_BLUE = '#716CB8',
    PURPLE = '#B29AEB',
    TIFFANY_BLUE = '#80D8D8',
    JUNGLE_GREEN = '#99DFCF',
    HONEY_YELLOW = '#F6D688'
}
